module.exports = __webpack_public_path__ + "img/hc-icon03.26e58103.svg";